import {
  groupByLimitList,
  widgetTypeThatCanHaveSeveralGroupBy,
} from "Components/WidgetSettingsComponent/widgetSettingsUtils.js"

import { isFilterWidget, getFieldWithUuid } from "Utils/widgetsUtils"

import { getAllFieldsRelated } from "Utils/dataCatalogueUtils.js"

export const getCalculusToDisplay = widgetInfo => {
  var calculusToReturn = "sum"
  var groupByCalculus = widgetInfo?.groupBy?.[0]?.calculus
  var distinct = widgetInfo?.groupBy?.[0]?.distinct
  if (widgetInfo.widgetType === "counter" && groupByCalculus === "count" && distinct) {
    calculusToReturn = "countDistinct"
  } else if (groupByCalculus) {
    calculusToReturn = groupByCalculus
  }
  return calculusToReturn
}

export const getMaximumNumberFields = (modalType, widgetInfo) => {
  if (
    modalType === "data" &&
    ((isFilterWidget(widgetInfo) && widgetInfo?.widgetType !== "searchBar") ||
      [
        "gaugeChart",
        "evolutionWidget",
        "treeMap",
        "heatMap",
        "heatMapRisk",
        "cloudWords",
        "fillingGauge",
      ].includes(widgetInfo?.widgetType))
  ) {
    return 1
    // Spefiic to radarChart
  } else if (
    modalType === "data" &&
    widgetInfo?.widgetType === "radarChart" &&
    widgetInfo?.groupBy.length == 2
  ) {
    return 1
  } else if (
    modalType === "groupBy" &&
    widgetInfo?.widgetType === "radarChart" &&
    widgetInfo?.data.length > 1
  ) {
    return 1
  } else if (
    modalType === "groupBy" &&
    widgetTypeThatCanHaveSeveralGroupBy.includes(widgetInfo?.widgetType)
  ) {
    const widget = groupByLimitList.find(widget => widget.type === widgetInfo?.widgetType)
    return widget?.limit
  } else if (modalType === "data") {
    return 1000
  } else if (["category", "groupBy", "dependsOnField"].includes(modalType)) {
    return 1
  }
  return 0
}

export const itShouldDislayTopFlopSelection = (
  sortingType,
  sortingTypes,
  fieldsForTopFlopSelection
) => {
  if (sortingType === undefined) return false

  var sortingTypeIsAll = sortingType === sortingTypes.ALL_RESULT
  if (sortingTypeIsAll || fieldsForTopFlopSelection.length <= 1) {
    return false
  }
  return true
}

export const itShouldDisplayLimitValueInputSelection = (sortingType, sortingTypes, widgetInfo) => {
  if (sortingType === undefined) return false

  var sortingTypeIsAll = sortingType === sortingTypes.ALL_RESULT
  if (sortingTypeIsAll || widgetInfo?.data.length === 0) {
    return false
  }
  return true
}

export const defaultDisplayObject = {
  dataSelection: true,
  categorySelection: false,
  groupBySelection: true,
  dependsOnSelection: false,
  someResultSelection: false,
  conditionBloc: true,
  filterTypeChoice: false,
  sortingSelection: false,
  frequencySelection: true,
  topFlopFieldSelection: false,
  limitValueInput: false,
  dateSelectionName: false,
  dataSelectionX: false,
  dataSelectionY: false,
  groupBySelectionX: false,
  groupBySelectionY: false,
  dataSelectionValue: false,
  hierarchyConfig: false,
}

export const getNewDisplayContentObj = (widgetInfo, fieldsData, options) => {
  var { sortingTypes, isPossibleTypeToSort, isPossibleTypeToSortBestResult } = options

  var newDisplayObject = {
    ...defaultDisplayObject,
  }

  if (isFilterWidget(widgetInfo)) {
    newDisplayObject = {
      ...newDisplayObject,
      categorySelection: false,
      groupBySelection: false,
      conditionBloc: false,
      filterTypeChoice: true,
    }
  }

  // Hierarchical filter: keep the standard data selection (data[0] = id field to filter on,
  // required by onSelectFilterValueWrapperFunc which reads data[0].id), drop the generic
  // single/multi filter-type picker, and expose the custom relation/parentSide/label section.
  if (widgetInfo.widgetType === "hierarchicalFilter") {
    newDisplayObject["filterTypeChoice"] = false
    newDisplayObject["hierarchyConfig"] = true
    // Conditions : restreignent les entités proposées (ex. écarter les PCA archivés). Appliquées
    // par `hierarchyConditions.js` + `pruneHierarchyNodes`, pas par la requête de l'arbre.
    newDisplayObject["conditionBloc"] = true
  }

  if (widgetInfo.widgetType === "dropdownList") {
    newDisplayObject["conditionBloc"] = true
  }

  //SORT
  var sortingTypeTemp = widgetInfo?.requestInformations?.sort?.sortingType
  const canBeSorted = isPossibleTypeToSort.includes(widgetInfo.widgetType)
  const sortingIs_All = [undefined, sortingTypes.ALL_RESULT].includes(sortingTypeTemp)
  newDisplayObject["sortingSelection"] = canBeSorted && sortingIs_All

  //BEST/WORST TOP/FLOP RESULT
  if (isPossibleTypeToSortBestResult.includes(widgetInfo.widgetType)) {
    newDisplayObject["someResultSelection"] = true
  }

  var fieldsForTopFlopSelection = []
  if (widgetInfo?.data?.length) {
    fieldsForTopFlopSelection = getAllFieldsRelated(fieldsData, widgetInfo.data?.[0]?.id)
  }

  var newDisplayTopFlopValue = itShouldDislayTopFlopSelection(
    sortingTypeTemp,
    sortingTypes,
    fieldsForTopFlopSelection
  )
  newDisplayObject["topFlopFieldSelection"] = newDisplayTopFlopValue

  var newDisplayLimitValueInput = itShouldDisplayLimitValueInputSelection(
    sortingTypeTemp,
    sortingTypes,
    widgetInfo
  )
  newDisplayObject["limitValueInput"] = newDisplayLimitValueInput

  if (widgetInfo.widgetType === "counter") {
    newDisplayObject["dataSelection"] = false
  }

  if (["gaugeChart", "evolutionWidget", "cloudWords"].includes(widgetInfo.widgetType)) {
    newDisplayObject["groupBySelection"] = false
  }

  if (["multiGauge", "evolutionWidget"].includes(widgetInfo.widgetType)) {
    newDisplayObject["dependsOnSelection"] = true
  }

  if (widgetInfo.widgetType === "rangeFilter") {
    newDisplayObject["groupBySelection"] = true
    newDisplayObject["filterTypeChoice"] = false
  }

  if (["fillingGauge"].includes(widgetInfo.widgetType)) {
    newDisplayObject["groupBySelection"] = false
    newDisplayObject["dependsOnSelection"] = true
  }

  var newFrequencyVisibility = false
  if (widgetInfo.groupBy.length) {
    var uuid = widgetInfo.groupBy[0].id
    var field = getFieldWithUuid(fieldsData, uuid)
    var fieldType = field?.dataType
    if (fieldType === "Date" || fieldType === "Timestamp") newFrequencyVisibility = true
  }

  if (widgetInfo.widgetType === "bubbleChart") {
    newDisplayObject["dataSelection"] = false
    newDisplayObject["dataSelectionName"] = true
    newDisplayObject["dataSelectionX"] = true
    newDisplayObject["dataSelectionY"] = true
    newDisplayObject["dataSelectionValue"] = true
  }

  if (widgetInfo.widgetType === "heatMap") {
    newDisplayObject["dataSelection"] = false
    newDisplayObject["groupBySelection"] = false
    newDisplayObject["groupBySelectionX"] = true
    newDisplayObject["groupBySelectionY"] = true
    newDisplayObject["dataSelectionValue"] = true
  }

  if (widgetInfo.widgetType === "heatMapRisk") {
    newDisplayObject["dataSelection"] = false
    newDisplayObject["dataSelectionName"] = true
    newDisplayObject["groupBySelection"] = false
    newDisplayObject["dataSelectionX"] = true
    newDisplayObject["dataSelectionY"] = true
    newDisplayObject["dataSelectionValue"] = false
  }

  newDisplayObject["frequencySelection"] = newFrequencyVisibility

  return newDisplayObject
}

export const widgetInfoAngleIsFrom0To360degres = widgetInfo => {
  return widgetInfo?.widgetProps?.startAngle === 0 && widgetInfo?.widgetProps?.endAngle === 360
}

export const getPieChartAccurateType = widgetInfo => {
  let pieTypeValue = "pieChart"
  var anglesAre0To360 = widgetInfoAngleIsFrom0To360degres(widgetInfo)
  if (widgetInfo?.data.length < 2) {
    pieTypeValue = anglesAre0To360 ? "pieChart" : "semiPieChart"
  } else {
    pieTypeValue = anglesAre0To360 ? "doublePieChart" : "doubleSemiPieChart"
  }
  return pieTypeValue
}

export const canDisplayAdvancedToggle = (widgetInfo, fieldType) => {
  const { widgetType, widgetCategory } = widgetInfo
  const unauthorizedCategory = ["filter"]
  const unauthorizedType = ["pipeline"]
  const unauthorizedFields = [
    "name",
    "x",
    "y",
    "value",
    "x_groupBy",
    "y_groupBy",
    "partitionBy",
    "orderBy",
    "frameClause",
    "id_redirect",
  ]

  const categoryIsUnauthorized = unauthorizedCategory.includes(widgetCategory)
  const typeIsUnauthorized = unauthorizedType.includes(widgetType)
  const fieldTypeIsUnauthorized = unauthorizedFields.includes(fieldType)

  if (categoryIsUnauthorized || typeIsUnauthorized || fieldTypeIsUnauthorized) return false
  if (fieldType === "groupBy") return ["table", "ag_table"].includes(widgetInfo.widgetType)
  else return widgetType !== "gaugeChart"
}
